import React from 'react';
import {
  CONTENTTYPE_FILE,
  CONTENTTYPE_TEXT,
} from '../../../../../constants/api';
import { getAttr } from '../../../../../features/helpers/apiHelpers';
import { FrontImageFieldWrite } from './frontImageField/FrontImageFieldWrite';

const FrontImageField = ({
  fieldData,
  onChange,
  isEditMode,
  validationEntity,
}) => {
  const [fileContent] = fieldData.fileContent || [];
  const [textContent] = fieldData.textContent || [];

  const fileName = getAttr(fileContent, 'fileName');
  const downloadUrl = getAttr(fileContent, 'urlToDownload');
  const altText = getAttr(textContent, 'textContent');

  const onChangeFile = (value, isDeleteOperation) => {
    onChange(value, CONTENTTYPE_FILE, false, isDeleteOperation);
    onChangeText('');
  };
  const onChangeText = (value) => onChange(value, CONTENTTYPE_TEXT);

  return isEditMode ? (
    <FrontImageFieldWrite
      fileName={fileName}
      altText={altText}
      onChangeFile={onChangeFile}
      onChangeText={onChangeText}
      downloadUrl={downloadUrl}
      validationEntity={validationEntity}
    />
  ) : null;
};

export { FrontImageField };
